import type { Column } from '@/components/Organisms/DataTable/DataTable.types';

export const statusesFilterOptionsInvoicePaymentLock = [
	{ label: 'Checkout Session', value: 'session' },
	{ label: 'Payment Link', value: `link` },
];

export const columns: Column[] = [
	{
		key: 'invoiceNumber',
		label: 'Invoice Number',
		type: 'string',
		width: '120px',
		sorter: true,
	},
	{
		key: 'clinicName',
		type: 'string',
		width: '200px',
		label: 'Clinic',
		sorter: true,
	},
	{
		key: 'userName',
		label: 'User Name',
		width: '250px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'userEmail',
		width: '250px',
		label: 'Email',
		type: 'string',
		sorter: true,
	},
	{
		key: 'sessionTime',
		label: 'Locked At',
		width: '100px',
		type: 'date',
		sorter: true,
	},
	{
		key: 'aging',
		label: 'Aging (days)',
		width: '80px',
		type: 'number',
		sorter: true,
	},
	{
		key: 'userSelectedClinics',
		label: 'Selected Clinic(s)',
		width: '120px',
		type: 'string',
		sorter: false,
		hideColumnFilter: true,
	},
	{
		key: 'url',
		label: 'Link',
		width: '40px',
		hideColumnFilter: true,
	},
];
